export type ProductModel = {
  id: number;
  voidedAt?: object;
  productId: string;
  productName: string;
  productVariantName: string;
  productVariantSku: string;
  currencyCode: string;
  price: number;
  rotatingEntryToken: string;
  barcode: string;
  renderType: string;
  isSecureEntry: boolean;
  termsAndConditions: string;
};

export function isProduct(item: any): item is ProductModel {
  return 'productId' in item && 'productName' in item;
}
